<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.isAlive"/>
    </keep-alive>
    <router-view v-if="!$route.meta.isAlive"></router-view>
  </div>
</template>

<script>

export default {
  data() {
    return {
      makeupInfoDialog: true,
    }
  },
  mounted() {
    let url = window.location.href;
    let migrantFiles = url.indexOf("migrantFiles")>-1;
    console.log(process.env,11999,process.env.NODE_ENV != 'development',migrantFiles)
    
    if(process.env.NODE_ENV != 'development' && migrantFiles) {
      // 是否是微信
      var ua = navigator.userAgent.toLowerCase();
      var isWeixin = ua.indexOf('micromessenger') != -1;
      if (!isWeixin) {
        window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=888"
      }
    }

  },
  methods: {},
}
</script>
<style lang="less">
//html, body, #app {
//  height: 100%;
//}
</style>
